export default __webpack_public_path__ + "static/media/movie.1244282e.svg";